import React from "react";

export const EDGE_RUNTIME_HOSTS_PATH = "/gateway/plc-runtime-fleet?view=hosts";

export const driverRuntimeAllowsDeviceCreation = (runtimeStatus) => runtimeStatus?.available === true;

export function EdgeRuntimeConfigurationLink({ className = "gwSecondaryBtn" }) {
  return (
    <a className={className} href={EDGE_RUNTIME_HOSTS_PATH}>
      Configure an enrolled runtime
    </a>
  );
}
